import React from 'react';
import { Typography } from 'src/components';
import type { CodeData } from 'src/components/Strategy/shared/types';

interface CodeTooltipContentProps {
  codeData?: CodeData;
}

const CodeTooltipContent = ({ codeData }: CodeTooltipContentProps) => {
  if (!codeData) {
    return (
      <Typography className="text-xs text-neutral-600 leading-tight">
        Loading code information...
      </Typography>
    );
  }

  return (
    <div className="flex flex-col gap-1 max-h-32 overflow-hidden overflow-y-auto">
      {codeData.category && (
        <Typography className="text-sm leading-tight">
          {codeData.category}
        </Typography>
      )}
      {codeData.sub_categories && codeData.sub_categories.length > 0 && (
        <Typography className="text-xs text-neutral-600 leading-tight">
          {codeData.sub_categories.join(', ')}
        </Typography>
      )}
      <Typography className="text-xs text-neutral-600 leading-tight">
        {codeData.description || 'No description available.'}
      </Typography>
    </div>
  );
};

export default CodeTooltipContent;
